/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Form_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit practice conversation" |
*
* @param {Practice_Form_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_form_edit_title = /** @type {((inputs?: Practice_Form_Edit_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Form_Edit_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefengesprek bewerken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la conversation d’entraînement")
	return /** @type {LocalizedString} */ ("Edit practice conversation")
});